import { LogIn, Sparkles, ShieldCheck } from "lucide-react";
import { Button } from "./ui/button";

// Shown on Step 01 when the visitor isn't signed in — creation requires an account so ducks save to a profile.
export const SignInGate = ({ onSignIn }) => (
  <div data-testid="signin-gate" className="rounded-3xl border-2 border-dashed border-border bg-card/60 p-10 sm:p-16 text-center max-w-2xl mx-auto animate-pop">
    <div className="mx-auto mb-6 grid place-items-center h-16 w-16 rounded-2xl bg-accent/15 text-accent">
      <Sparkles className="h-8 w-8" />
    </div>
    <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Sign in to start your duck</h2>
    <p className="text-muted-foreground mt-3 max-w-md mx-auto">
      Create an account with just your email and a one-time code. Every duck you make is saved to your profile so you can reopen, reorder or share it anytime.
    </p>
    <Button data-testid="gate-signin-btn" onClick={onSignIn} className="mt-7 rounded-full h-12 px-8 font-bold gap-2">
      <LogIn className="h-5 w-5" /> Sign in to create
    </Button>
    <p className="mt-4 text-xs text-muted-foreground flex items-center justify-center gap-1.5">
      <ShieldCheck className="h-3.5 w-3.5" /> No password — we email you a 6-digit code.
    </p>
  </div>
);
